import { useEffect, useRef, useState } from "react";
import Svg from "react-native-svg";
import CryptoJS from "crypto-js";
import { useLocation, Redirect } from "react-router-dom";
import PopOverModal from "../../../../../components/popover";
import { notificationBellSVG } from "../../../../../utils/svg";
import {
  Box,
  Button,
  HStack,
  Pressable,
  Spinner,
  Text,
  VStack,
  useMediaQuery,
} from "native-base";
import NotificationCard from "../../../../../containers/notificationList";
import CustomButton from "../../../../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../../utils/fonts";
import { COLORS } from "../../../../../utils/colors";
import DividerLine from "../../../../../components/divider";
import CustomModal from "../../../../../components/modal";
import {
  EventNotificationModal,
  GeneralNotificationModal,
} from "../notificationModals";
import { MOBILE_VIEW_WIDTH } from "../../../../../utils/screens";
import { Toaster } from "../../../../../components/toaster";
import "./style.css";
import {
  markAsReadNotificationAPI,
  sendNotificationAPI,
} from "../../../../../api/apis/notification";
import { uploadFileAPI } from "../../../../../api/apis/workflow";
import NoDataFound from "../../../../../components/noDataFound";
import { useDispatch, useSelector } from "react-redux";
import ContainerCards from "../../../../../components/cards";
import MobileModelSheet from "../../../../../components/actionSheet";
import { LoaderAnimation } from "../../../../../components/spinner";
import { hasPermission } from "../../../../../utils/permission";
import { eventDetailsAPI } from "../../../../../api/apis/event";
import { activeEventTab } from "../../../../../store/reducers/eventSlice";
import config from "../../../../../utils/config";
import { useHistory } from "react-router-dom";

export const NotificationList = ({
  notificationData,
  unreadCount,
  getNotification,
}) => {
  const toaster = Toaster();
  const dispatch = useDispatch();
  const history = useHistory();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectTo, setRedirectTo] = useState("");
  const [count, setCount] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const location = useLocation();

  useEffect(() => {
    setCount(unreadCount);
  }, [unreadCount]);

  if (shouldRedirect) {
    return <Redirect to={redirectTo} />;
  }

  const onOpenPress = () => {
    if (location.pathname !== "/notification") setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const handleMarkAsReadNotification = async (
    id,
    status,
    event_id,
    package_id,
    type,
    mis
  ) => {
    LoaderAnimation.show();
    let allNotification = { notification_ids: [] };
    if (typeof id === "string" && !status) {
      allNotification["notification_ids"].push({
        notification_id: id,
      });
    }
    if (allNotification["notification_ids"].length > 0) {
      let res = await markAsReadNotificationAPI(allNotification);
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        let count = await getNotification(1, true, notificationData.length);
        setCount(count);
      }
    } else {
      let res = await markAsReadNotificationAPI();
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        let count = await getNotification(1, true, notificationData.length);
        setCount(count);
      }
    }
    if (event_id) {
      if (type !== "expense") {
        let res = await eventDetailsAPI(event_id);
        if (res.error) {
          toaster(res.message, "error", "error");
          LoaderAnimation.hide();
          return;
        } else {
          sessionStorage.setItem(
            "event",
            CryptoJS.AES.encrypt(
              JSON.stringify(res?.data?.data?.data),
              config.eventKey
            ).toString()
          );
        }
      }
      if (type === "expense") {
        if (mis && mis === "event") {
          dispatch(activeEventTab("event"));
        } else {
          dispatch(activeEventTab("mice"));
        }
        history.push("/dashboard");
      } else {
        if (location.pathname !== "/event-detail") {
          setRedirectTo("/event-detail");
          setShouldRedirect(true);
        } else {
          window.location.reload();
        }
      }
    } else if (package_id) {
      if (type === "package_approved") sessionStorage.setItem("package", type);
      if (location.pathname !== "/home") {
        setRedirectTo("/home");
        setShouldRedirect(true);
      }
      dispatch(activeEventTab("packages"));
    } else if (location.pathname !== "/home") {
      if (type === "expense") {
        if (mis && mis === "event") {
          dispatch(activeEventTab("event"));
        } else {
          dispatch(activeEventTab("mice"));
        }
        setRedirectTo("/dashboard");
        setShouldRedirect(true);
      } else {
        setRedirectTo("/home");
        setShouldRedirect(true);
      }
    } else if (type === "package_rejected" && location.pathname === "/home") {
      dispatch(activeEventTab("mice"));
    }
    LoaderAnimation.hide();
  };

  const handleMarkAsReadNotifications = async (
    id,
    status,
    event_id,
    package_id,
    type,
    mis
  ) => {
    if (type === "expense") {
      if (mis && mis === "event") {
        dispatch(activeEventTab("event"));
      } else {
        dispatch(activeEventTab("mice"));
      }
      history.push("/dashboard");
    }
    if (event_id && type !== "expense") {
      let res = await eventDetailsAPI(event_id);
      if (res.error) {
        toaster(res.message, "error", "error");
        LoaderAnimation.hide();
        return;
      } else {
        sessionStorage.setItem(
          "event",
          CryptoJS.AES.encrypt(
            JSON.stringify(res?.data?.data?.data),
            config.eventKey
          ).toString()
        );
      }
      if (location.pathname !== "/event-detail") {
        setRedirectTo("/event-detail");
        setShouldRedirect(true);
      } else {
        window.location.reload();
      }
    } else if (package_id) {
      if (type === "package_approved") sessionStorage.setItem("package", type);
      if (location.pathname !== "/home") {
        setRedirectTo("/home");
        setShouldRedirect(true);
      }
      dispatch(activeEventTab("packages"));
    } else if (location.pathname !== "/home") {
      if (type === "expense") {
        if (mis && mis === "event") {
          dispatch(activeEventTab("event"));
        } else {
          dispatch(activeEventTab("mice"));
        }
        setRedirectTo("/dashboard");
        setShouldRedirect(true);
      } else {
        setRedirectTo("/home");
        setShouldRedirect(true);
      }
    } else if (type === "package_rejected" && location.pathname === "/home") {
      dispatch(activeEventTab("mice"));
    }
  };

  const popOverHeader = (
    <HStack
      justifyContent={"space-between"}
      alignItems={"center"}
      width={MobileWindow && "100%"}
    >
      <Text fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT} fontSize={"20px"}>
        Notifications
      </Text>
      {notificationData.length > 0 && count > 0 && (
        <Button variant={"none"} onPress={handleMarkAsReadNotification}>
          <Text
            width="fit-content"
            bgColor="none"
            color={COLORS.THEME_COLOR}
            fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
            fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          >
            Mark all as read
          </Text>
        </Button>
      )}
    </HStack>
  );

  const popOverBody = () => {
    return notificationData && notificationData.length > 0 ? (
      notificationData.map((item, ind) => {
        if (ind < 3)
          return (
            <>
              <Box
                ml={!MobileWindow && 4}
                mr={!MobileWindow && 4}
                mb={2}
                style={{ position: "relative" }}
              >
                {/* <Pressable
                  onPress={() => {
                    if (!item.status)
                      handleMarkAsReadNotification(item.id, item.status);
                  }}
                > */}
                <ContainerCards
                  background={COLORS.WHITE_COLOR}
                  height={"auto"}
                  width="100%"
                  border={MobileWindow && `0.5px solid rgb(191, 191, 191)`}
                  // boxShadow={MobileWindow && "none"}
                >
                  <Box p={3} width={"100%"}>
                    <NotificationCard
                      key={item.id}
                      header={!item.status ? item.description : ""}
                      body={item.status ? item.description : ""}
                      timeline={item.datetime}
                      item={item}
                      handleMarkAsReadNotification={
                        handleMarkAsReadNotification
                      }
                      handleMarkAsReadNotifications={
                        handleMarkAsReadNotifications
                      }
                    />
                  </Box>
                </ContainerCards>
                {/* </Pressable> */}
                {/* <Box mt={2}></Box> */}
              </Box>
            </>
          );
      })
    ) : (
      <Box py={8} mb={5}>
        <NoDataFound dataName="notification" image={false} />
      </Box>
    );
  };

  const popOverFooter =
    notificationData && notificationData.length > 0 ? (
      <Box mx={MobileWindow && "auto"}>
        <a style={{ textDecoration: "none" }} href="/notification">
          <CustomButton
            isOutline
            text="Read More"
            textColor={COLORS.BLACK_COLOR}
            bgColor={COLORS.BLACK_COLOR}
            borderRadius="50px"
            width="fit-content"
            py={3}
            mt="4"
          />
        </a>
      </Box>
    ) : null;

  return (
    <>
      {!MobileWindow ? (
        <PopOverModal
          isOpen={isOpen}
          onClose={onClose}
          onOpenPress={onOpenPress}
          maxHeight="500px"
          svg={
            <Svg width="38" height="38" viewBox="0 0 28 26">
              {notificationBellSVG}
              {count > 0 && (
                <>
                  <rect
                    x="8.5"
                    y="0"
                    width="18"
                    height="13"
                    rx="8"
                    fill={COLORS.THEME_COLOR}
                  />
                  <text
                    x="18"
                    y="9.5"
                    fill="white"
                    fontSize="9"
                    textAnchor="middle"
                  >
                    {count > 99 ? `99+` : count}
                  </text>
                </>
              )}
            </Svg>
          }
          height="auto"
          header={popOverHeader}
          body={popOverBody()}
          footer={popOverFooter}
          type="notify"
        />
      ) : (
        <div onClick={() => onOpenPress()}>
          <Svg width="30" height="30" viewBox="0 0 24 25">
            {notificationBellSVG}
            {count > 0 && (
              <>
                <rect
                  x="6.6"
                  y="0"
                  width="18"
                  height="13"
                  rx="8"
                  fill={COLORS.THEME_COLOR}
                />
                <text
                  x="15.5"
                  y="9.5"
                  fill="white"
                  fontSize="8"
                  textAnchor="middle"
                >
                  {count > 99 ? `99+` : count}
                </text>
              </>
            )}
          </Svg>
        </div>
      )}
      {MobileWindow && isOpen && (
        <MobileModelSheet
          isOpen={isOpen}
          onClose={onClose}
          header={popOverHeader}
          body={popOverBody()}
          footer={popOverFooter}
        />
      )}
    </>
  );
};

export const SendNotification = () => {
  const toaster = Toaster();
  const [data, setData] = useState({
    event_id: "",
    text: "",
    people: "",
    url: "",
  });
  const childRef = useRef();
  const [notificationType, setNotificationType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const eventTab = activeTab === "event" ? "Event" : "MICE";
  const [forceRemount, setForceRemount] = useState(false);

  const customTextStyle = {
    transform: MobileWindow && [{ translateX: 5 }, { translateY: -2 }],
  };
  const [tabActiveButton, setTabActiveButton] = useState("Image");

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const openModal = () => {
    setShowModal(true);
    setForceRemount(!forceRemount);
    setTabActiveButton("Image");
    scrollToTop();
  };

  const closeModal = () => {
    setData((prevData) => ({
      ...prevData,
      event_id: "",
      text: "",
      people: [],
      url: "",
    }));
    setForceRemount(!forceRemount);
    setShowModal(false);
    scrollToTop();
  };

  const onOpenPress = () => {
    setForceRemount(!forceRemount);
    setTabActiveButton("Image");
    scrollToTop();
    setIsOpen(true);
  };

  const onClose = () => {
    setData((prevData) => ({
      ...prevData,
      event_id: "",
      text: "",
      people: [],
      url: "",
    }));
    setForceRemount(!forceRemount);
    scrollToTop();
    setIsOpen(false);
  };

  const popOverHeader = () => {
    return <Text>Send Notification</Text>;
  };

  const popOverMobileBody = () => {
    return (
      <VStack space={3} pb={10}>
        <Box
          bg={COLORS.NOTIFICATION_MODEL_BG_COLOR}
          py={6}
          px={5}
          borderRadius={"8px"}
          style={{
            border: `2px solid ${COLORS.NOTIFICATION_BORDER_COLOR}`,
          }}
        >
          <HStack space={2} alignItems={"center"}>
            <Svg width="24" height="25" viewBox="0 0 24 25">
              {notificationBellSVG}
            </Svg>
            <Text
              onPress={() => {
                setNotificationType("general");
                onClose();
                openModal();
              }}
              color={COLORS.BLACK_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
            >
              General Notification
            </Text>
          </HStack>
        </Box>
        <Box
          bg={COLORS.NOTIFICATION_MODEL_BG_COLOR}
          py={6}
          px={5}
          borderRadius={"8px"}
          style={{
            border: `2px solid ${COLORS.NOTIFICATION_BORDER_COLOR}`,
          }}
        >
          <HStack space={2} alignItems={"center"}>
            <Svg width="24" height="25" viewBox="0 0 24 25">
              {notificationBellSVG}
            </Svg>
            <Text
              onPress={() => {
                setNotificationType("event");
                onClose();
                openModal();
              }}
              color={COLORS.BLACK_COLOR}
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
            >
              {eventTab} Notification
            </Text>
          </HStack>
        </Box>
      </VStack>
    );
  };

  const popOverBody = () => {
    return (
      <VStack space={3} p={2}>
        <HStack space={2} alignItems={"center"}>
          <Svg width="24" height="25" viewBox="0 0 24 25">
            {notificationBellSVG}
          </Svg>
          <Text
            onPress={() => {
              setNotificationType("general");
              onClose();
              openModal();
            }}
            color={COLORS.BLACK_COLOR}
            fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            General Notification
          </Text>
        </HStack>
        <DividerLine direction="horizontal" width="100%" />
        <HStack space={2} alignItems={"center"}>
          <Svg width="24" height="25" viewBox="0 0 24 25">
            {notificationBellSVG}
          </Svg>
          <Text
            onPress={() => {
              setNotificationType("event");
              onClose();
              openModal();
            }}
            color={COLORS.BLACK_COLOR}
            fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            {eventTab} Notification
          </Text>
        </HStack>
      </VStack>
    );
  };

  const getPopupModalTitle = () => {
    if (notificationType === "general")
      return <Text>General Notification</Text>;
    else if (notificationType === "event")
      return <Text>{eventTab} Notification</Text>;
  };

  const getPopupModalChildren = () => {
    if (notificationType === "general")
      return (
        <GeneralNotificationModal
          tabActiveButton={tabActiveButton}
          setTabActiveButton={setTabActiveButton}
          forceRemount={forceRemount}
          data={data}
          scrollToTop={scrollToTop}
          setData={setData}
          ref={childRef}
        />
      );
    else if (notificationType === "event")
      return (
        <EventNotificationModal
          tabActiveButton={tabActiveButton}
          setTabActiveButton={setTabActiveButton}
          forceRemount={forceRemount}
          data={data}
          scrollToTop={scrollToTop}
          setData={setData}
          ref={childRef}
        />
      );
  };

  function isYouTubeLink(url) {
    const youtubeRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/|c\/|user\/[^/]+\/live\/|attribution_link\?a=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    return youtubeRegex.test(url);
  }

  const modalFooter = (
    <Box width={MobileWindow && "100%"}>
      <CustomButton
        onPress={async () => {
          if (notificationType === "general") {
            if (data.text === "") {
              toaster("Please enter message to send", "error", "error");
              return;
            } else if (data.text.length > 0 && data.text.length > 5000) {
              toaster(
                "Please enter notification message less than 5000 characters",
                "error",
                "error"
              );
              return;
            }
            if (data.people.length === 0) {
              toaster("Please select file", "error", "error");
              return;
            }
          }

          if (notificationType === "event") {
            if (data.text === "") {
              toaster("Please enter message to send", "error", "error");
              return;
            } else if (data.text.length > 0 && data.text.length > 5000) {
              toaster(
                "Please enter notification message less than 5000 characters",
                "error",
                "error"
              );
              return;
            }
            if (data.event_id === "") {
              toaster(`Please select ${eventTab}`, "error", "error");
              return;
            }
          }

          // if (data.url === "") {
          //   if (tabActiveButton === "Image") {
          //     toaster(`Please select Image`, "error", "error");
          //     return;
          //   } else {
          //     toaster(`Please add video link`, "error", "error");
          //     return;
          //   }
          // }

          LoaderAnimation.show();
          let payload = {
            notification_type:
              notificationType === "event"
                ? activeTab === "packages"
                  ? "mice"
                  : activeTab
                : notificationType,
            event_id: data.event_id,
            description: data.text,
            employee: data.people === "" ? [] : data.people,
            read: false,
          };

          if (data.people.length > 0) {
            let docs = [];
            let res = await uploadFileAPI(data.people, "file", "people");
            res.map((item) => {
              if (item.error) {
                toaster("Upload file failed", "error", "error");
                LoaderAnimation.hide();
                return;
              }
              if (item.data.data.data) {
                docs.push({
                  doc_type: item.data.data.data.doc_type,
                  file_size: item.data.data.data.file_size.toString(),
                  file_name: item.data.data.data.file_name,
                  uploaded_time: new Date(),
                });
              }
            });
            payload.employee = docs;
          }
          let updateUrl = "";
          let selectedUrl = childRef.current.selectedUrl();
          setData({ ...data, url: selectedUrl });
          if (tabActiveButton === "Image" && selectedUrl !== "") {
            let docs = [];
            let res = await uploadFileAPI(selectedUrl, "image", "image");
            res.map((item) => {
              if (item.error) {
                toaster("Upload file failed", "error", "error");
                LoaderAnimation.hide();
                return;
              }
              if (item.data.data.data) {
                docs.push({
                  doc_type: item.data.data.data.doc_type,
                  file_size: item.data.data.data.file_size.toString(),
                  file_name: item.data.data.data.file_name,
                  uploaded_time: new Date(),
                });
              }
            });
            updateUrl = docs;
          } else {
            updateUrl = selectedUrl;
          }

          if (tabActiveButton === "Image" && updateUrl !== "") {
            payload.image = updateUrl?.[0];
          } else if (tabActiveButton === "Video" && updateUrl !== "") {
            if (!isYouTubeLink(updateUrl)) {
              toaster("Enter correct link", "error", "error");
              LoaderAnimation.hide();
              return;
            }
            payload.video = {
              path: "",
            };
            payload.video.path = updateUrl;

            const getYouTubeVideoId = (url) => {
              const regExp =
                /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&amp;]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
              const match = url.match(regExp);
              return match && match[1] ? match[1] : null;
            };
            const videoId = getYouTubeVideoId(updateUrl);
            payload.thumbnail = videoId
              ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
              : null;
          }
          let res = await sendNotificationAPI(payload);
          if (res.error) {
            toaster(res.message, "error", "error");
            LoaderAnimation.hide();
            return;
          } else {
            toaster("Notification has been sent", "success", "success");
            closeModal();
          }
          LoaderAnimation.hide();
        }}
        text="Send"
        color={COLORS.WHITE_COLOR}
      />
    </Box>
  );

  return (
    <>
      <Box mr={MobileWindow ? 1 : 3} style={customTextStyle}>
        {!MobileWindow ? (
          hasPermission("SEND_ALL_NOTIFICATION") ? (
            <PopOverModal
              isOpen={isOpen}
              onClose={onClose}
              onOpenPress={onOpenPress}
              button={!MobileWindow && true}
              type={MobileWindow && "three-dots"}
              svg={
                <Text
                  color={COLORS.WHITE_COLOR}
                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                  fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                >
                  Send Notification
                </Text>
              }
              body={popOverBody()}
            />
          ) : (
            <CustomButton
              onPress={() => {
                setNotificationType("event");
                onClose();
                openModal();
              }}
              height="45px"
              text="Send Notification"
            />
          )
        ) : hasPermission("SEND_ALL_NOTIFICATION") ? (
          <div class="three-dots-vertical" onClick={onOpenPress}>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        ) : (
          <div
            class="three-dots-vertical"
            onClick={() => {
              setNotificationType("event");
              onClose();
              openModal();
            }}
          >
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        )}
      </Box>
      {!MobileWindow ? (
        <CustomModal
          top={"120px"}
          isOpen={showModal}
          onClose={closeModal}
          header={getPopupModalTitle()}
          body={getPopupModalChildren()}
          footer={modalFooter}
          height={"45rem"}
        />
      ) : isOpen ? (
        <MobileModelSheet
          isOpen={isOpen}
          onClose={onClose}
          header={popOverHeader()}
          body={popOverMobileBody()}
        />
      ) : (
        showModal && (
          <MobileModelSheet
            isOpen={showModal}
            onClose={closeModal}
            header={getPopupModalTitle()}
            body={getPopupModalChildren()}
            footer={modalFooter}
          />
        )
      )}
    </>
  );
};
